import { useSearch } from "@tanstack/react-router"
import type { ReactElement } from "react"

import CertificateExpirationsTable from "@/screens/Companies/components/tables/CertificateExpirationsTable.tsx"
import { CompaniesTable } from "@/screens/Companies/components/tables/CompaniesTable"
import { ContactsTable } from "@/screens/Companies/components/tables/ContactsTable"
import { LocationsTable } from "@/screens/Companies/components/tables/LocationsTable"
import { SearchCategory } from "@/screens/Companies/types/enums"

export const TableContainer = (): ReactElement => {
  const { category } = useSearch({ from: "/app/companies/" })

  if (category === SearchCategory.COMPANY) {
    return <CompaniesTable />
  }

  if (category === SearchCategory.CONTACT) {
    return <ContactsTable />
  }
  if (category === SearchCategory.LOCATION) {
    return <LocationsTable />
  }
  if (category === SearchCategory.CERTIFICATION) {
    return <CertificateExpirationsTable />
  }

  return <>Please select a category</>
}
